import { useRef, useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import './resetPassword.scss';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';

function ResetPassword() {
  const inputNewPasswordRef = useRef<HTMLInputElement>(null);
  const inputConfirmPasswordRef = useRef<HTMLInputElement>(null);
  const location = useLocation();
  const [redirect, setRedirect] = useState<boolean>(false);
  const [code, setCode] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const email = queryParams.get('email');
    setCode(code);
    setEmail(email);
  }, [location.search]);

  if (code === null || email === null) {
    // Return loading indicator or placeholder while fetching data
    return <div>Loading ...</div>;
  }
  if (redirect) {
    return <Navigate to="/login" />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (inputNewPasswordRef?.current?.value !== inputConfirmPasswordRef?.current?.value) {
      setError("Your password didn't match");
    } else {
      try {
        await axios
          .post(`/op/auth/reset-password`, {
            email: email,
            password: inputNewPasswordRef?.current?.value,
            resetCode: code,
          })
          .then((response) => {
            setRedirect(true);
          });
      } catch (error:any) {
        setError(error.message);
      }
    }
  };

  return (
    <div id="Login" className="flex">
      <section className="">
        <img alt="Main Icon" className="main-logo" src="/images/sidebar_login.png" />
      </section>
      <section className="flex flex-col items-center justify-center grow">
        <div>
          <header className="flex flex-col gap-2 mb-10">
            <span className="text-5xl font-extrabold">Reset Password</span>
            <span className="" style={{ color: '#A6BCCC' }}>
            Enter your new password.
            </span>
          </header>
          <form className="fields-panel" onSubmit={handleSubmit}>
            <div className="mb-2">
              <label style={{ color: '#5A7283' }} className="text-sm mb-1">
                New Password
              </label>
              <input className="input-login" ref={inputNewPasswordRef} name="password" placeholder="Password" type="password" />
            </div>
            <div className="mb-2">
              <label style={{ color: '#5A7283' }} className="text-sm mb-1">
                Confirm Password
              </label>
              <input className="input-login" ref={inputConfirmPasswordRef} name="password" placeholder="Confirm Password" type="password" />
            </div>

            {error !== '' && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{error}</div>
              </div>
            )}
            <Button className="main-btn" type="submit">
              <span className="indicator-label text-sm">Submit</span>
            </Button>
          </form>
          <div className="flex gap-1 text-sm mt-3">
            <span>Already registered?</span>
            <span
              tabIndex={0}
              className="cursor-pointer font-medium underline "
              style={{ color: '#35B888', fontFamily: 'Inter' }}
              onClick={() => navigate('/login')}
            >
              Login
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ResetPassword;
